import React from "react";
import { Row, Col, Table } from "reactstrap";

const AdultShirtTable = () => {
  return (
    <Row>
      <Col style={{ marginTop: "10px" }}>
        Kokotaulukko:
        <Table striped>
          <thead>
            <tr>
              <th></th>
              <th>Kuminauha venyttämättä</th>
              <th>Sisälahje</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>XS</td>
              <td>58</td>
              <td>73</td>
            </tr>
            <tr>
              <td>S</td>
              <td>63</td>
              <td>75</td>
            </tr>
            <tr>
              <td>M</td>
              <td>68</td>
              <td>75</td>
            </tr>
            <tr>
              <td>L</td>
              <td>73</td>
              <td>77</td>
            </tr>
            <tr>
              <td>XL</td>
              <td>77</td>
              <td>80</td>
            </tr>
            <tr>
              <td>XXL</td>
              <td>82</td>
              <td>80</td>
            </tr>
            <tr>
              <td>3XL</td>
              <td>87</td>
              <td>80</td>
            </tr>
            <tr>
              <td>4XL</td>
              <td>90</td>
              <td>82</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default AdultShirtTable;
